module.exports = __webpack_public_path__ + "img/bell-black.c13bd50f.svg";